export default __webpack_public_path__ + "static/media/InsideKidneys_01.d199ae92.png";